import './AddChannel.scss'
import illustration from '../../assets/add-channel.svg'
import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Button, BlankSlate, Wrapper } from '../../lib'
import { teamStore, channelStore } from '../../app/stores'
import AddChannelForm from './AddChannelForm'

class AddChannel extends Component {
  constructor (props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.state = { success: false }
  }

  handleSubmit (form) {
    return channelStore
      .createChannel(form.channel.value)
      .then(newChannelKey => {
        if (newChannelKey) {
          const nextUrl = `channel/${newChannelKey}/embed`
          if (this.props.history) {
            this.props.history.push(nextUrl)
          } else if (this.props.push) {
            this.props.push(nextUrl)
          }
        }
      })
  }

  handleChange () {
    if (channelStore.error) {
      channelStore.clearError()
    }
  }

  render () {
    return (
      <div className='AddChannel'>
        <Wrapper>
          {teamStore.canAddChannel ? (
            <BlankSlate
              img={illustration}
              title={teamStore.activeChannels.length < 1 ? 'Create your first channel:' : 'Name your new channel:'}>
              <AddChannelForm
                onSubmit={this.handleSubmit}
                onChange={this.handleChange}
              />
            </BlankSlate>
          ) : (
            <BlankSlate
              img={illustration}
              title='You’ve reached your channel limit'>
              <p>
                To add another channel you'll need to
                <span>
                  &nbsp;
                  <Button styleType='text' to='/account/billing'>
                    upgrade your plan
                  </Button>
                  <br /> or&nbsp;
                </span>
                archive an active channel from Slack.
              </p>
            </BlankSlate>
          )}
        </Wrapper>
      </div>
    )
  }
}

AddChannel.displayName = 'AddChannel'

export default observer(AddChannel)



// WEBPACK FOOTER //
// ./src/channel/add/AddChannel.js